import Vue from 'vue'
import Router from 'vue-router'
// import Home from '../components/home.vue'
// import Test from '../components/test.vue'

Vue.use(Router)

// const Test = r => require.ensure([], () => r(require('./../components/test.vue')));
const Home = r => require.ensure([], () => r(require('./../components/home.vue')));
const handInput = r => require.ensure([], () => r(require('./../components/hand-input.vue')));
const charge = r => require.ensure([], () => r(require('../components/charge-connect.vue')));
const chargingProcess = r => require.ensure([], () => r(require('../components/charging-process.vue')));
const payBill = r => require.ensure([], () => r(require('../components/pay-bill.vue')));
const personalCenterCollection = r => require.ensure([], () => r(require('./../components/ep-personal-collection.vue')));
const personalCenter = r => require.ensure([], () => r(require('./../components/ep-personal-center.vue')));
const personalCenterOrder = r => require.ensure([], () => r(require('./../components/ep-personal-order.vue')));
const personalCenterHelp = r => require.ensure([], () => r(require('./../components/ep-personal-help.vue')));
const orderDetail = r => require.ensure([], () => r(require('./../components/ep-order-detail.vue')));
const coupon = r => require.ensure([], () => r(require('./../components/ep-coupon.vue')));
const personalAchieve = r => require.ensure([], () => r(require('./../increaseComponents/achieve/ep-personal-achieve.vue')));
const personalAchieveRule = r => require.ensure([], () => r(require('./../increaseComponents/achieve/achieve-rule.vue')));
const tempActive = r => require.ensure([], () => r(require('./../components/ep-temp-active.vue')));
const personalBalance = r => require.ensure([], () => r(require('./../components/ep-personal-balance.vue')));
const personalQuestion = r => require.ensure([], () => r(require('./../components/ep-personal-question.vue')));
const chargeActiveIframe = r => require.ensure([], () => r(require('./../components/charge-active-iframe.vue')));
const recommend = r => require.ensure([], () => r(require('./../increaseComponents/recommend/ep-recommend-index.vue')));
const recommendDetail = r => require.ensure([], () => r(require('./../increaseComponents/recommend/ep-recommend-detail.vue')));
const card = r => require.ensure([], () => r(require('./../increaseComponents/card/ep-card.vue')));
const userProtocol = r => require.ensure([], () => r(require('./../components/user-protocol.vue')));
const noticeCenter = r => require.ensure([], () => r(require('./../components/ep-personal-notice-center.vue')));

export default new Router({
  mode: 'history',
  // base: __dirname,
  routes: [
    {
      path: '/epower/epower.html',
      component: Home,
      meta: {
        title: '小桔充电'
      }
    },
    {
      path: '/epower/handInput',
      name: 'handInput',
      component: handInput
    },
    {
      path: '/epower/charge',
      component: charge,
      meta: {
        title: '费用确认'
      }
    },
    {
      path: '/epower/chargingProcess',
      component: chargingProcess,
      meta: {
        title: '小桔充电'
      }
    },
    {
      path: '/epower/payBill',
      component: payBill,
      meta: {
        title: '账单确认'
      }
    },
    {
      path: '/epower/personalCenterCollection',
      component: personalCenterCollection,
      meta: {
        title: '我的收藏'
      }
    },
    {
      path: '/epower/personalCenter',
      component: personalCenter,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/epower/personalCenterOrder',
      component: personalCenterOrder,
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/epower/personalCenterHelp',
      component: personalCenterHelp,
      meta: {
        title: '帮助'
      }
    },
    {
      path: '/epower/orderDetail',
      component: orderDetail,
      meta: {
        title: '订单详情'
      }
    },
    {
      path:'/epower/coupon',
      component:coupon,
      meta: {
        title: '我的优惠券'
      }
    },
    {
      path:'/epower/achieve',
      component:personalAchieve,
      meta: {
        title: '充电成就'
      }
    },
    {
      path:'/epower/achieveRule',
      component:personalAchieveRule,
      meta: {
        title: '充电成就'
      }
    },
    {
      path: '/epower/tempActive',
      component: tempActive,
      meta: {
        title: '喜迎新年 一元充电'
      }
    },
    {
      path: '/epower/personBalance',
      component: personalBalance,
      meta: {
        title: '充电余额'
      }
    },
    {
      path: '/epower/personalQuestion',
      component: personalQuestion,
      meta: {
        title: '常见问题'
      }
    },
    {
      path: '/epower/chargeActiveIframe/:city',
      component: chargeActiveIframe,
      meta: {
        title: '小桔充电'
      }
    },
    {
      path: '/epower/recommend',
      component: recommend,
      meta: {
        title: '推荐有奖'
      }
    },
    {
      path:'/epower/recommendDetail',
      component:recommendDetail,
      meta: {
        title:'奖励详情'
      }
    },
    {
      path:'/epower/card',
      component:card,
      meta: {
        title:'小桔充电，电车充电平台首选'
      }
    },{
      path:'/epower/userProtocol',
      component:userProtocol,
      meta: {
        title:'小桔充电，电车充电平台首选'
      }
    },{
      path:'/epower/noticeCenter',
      component:noticeCenter,
      meta: {
        title:'消息中心'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/pages/epower/router/index.js